import type { TError } from '@onesource/schemas';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import axios from '../../axios';
import { ENTITY } from '../entity';

/**
 * Form Submission response
 */
export interface TFormSubmission {
  id: string;
  formId: string;
  userId: string;
  submissionNumber: number;
  status: 'in_progress' | 'submitted';
  startedAt: string;
  submittedAt: string | null;
}

/**
 * Hook to start a new form submission
 */
export const useStartFormSubmission = () => {
  const queryClient = useQueryClient();

  return useMutation<TFormSubmission, TError, string>({
    mutationFn: async (formId: string) => {
      const res = await axios.post<TFormSubmission>(`/community-hub/forms/${formId}/submissions`);
      return res.data;
    },
    onSuccess: (_, formId) => {
      queryClient.invalidateQueries({ queryKey: [ENTITY, 'form', formId, 'submissions'] });
    },
  });
};
